module.exports = __webpack_public_path__ + "img/40_38_040_800.537ee25d.jpg";